import { useBreakpointUp } from '../../components/BreakpointProvider/useBreakpointUp.js';
export const BreakpointUp = ({
  children,
  matches
  // eslint-disable-next-line sonarjs/function-return-type -- this is totally valid here
}) => {
  const shouldRender = useBreakpointUp(matches);
  if (shouldRender) {
    return children;
  }
  return null;
};